module.exports = __webpack_public_path__ + "img/10.7cf0d3f8.png";